#@import Booking.Collections.Base
#@import Booking.Models.Reservation
#@export Booking.Collections.Reservations

class Booking.Collections.Reservations extends Booking.Collections.Base
  model: Booking.Models.Reservation

  url: ->
    "#{Booking.rootUrl}/reservations"
